import { Modal } from '@plick/ui';
import ReactPlayer from 'react-player';
import { Announcement } from '@interfaces/general';
import { AnnouncementOptionButtons } from '../shared/AnnouncementOptionButtons';
import { useRespondAnnouncement } from './hooks/useRespondAnnouncement';

interface Props {
  announcement: Announcement;
  isOpen: boolean;
  onClose: () => void;
}

export const CommunicationsModal = ({ announcement, isOpen, onClose }: Props) => {
  // Cada componente tiene su propia instancia para que isSubmitting sea local
  // (un click en el modal no debe deshabilitar otros banners/cards activos).
  const { respond, isSubmitting } = useRespondAnnouncement();

  const bgColor = announcement.bg_color || '#ffffff';
  const textColor = announcement.text_color || '#1A1A2E';

  return (
    <Modal
      padding="0rem"
      maxHeight="90vh"
      isOpen={isOpen}
      onClose={() => {
        // is_persistent bloquea cierre manual; isSubmitting evita doble ejecución
        if (!announcement.is_persistent && !isSubmitting) {
          onClose();
        }
      }}
      closableWaitingTime={announcement.delay_before_close || 0}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <div
        className="flex flex-col h-full rounded-lg overflow-hidden"
        style={{ backgroundColor: bgColor, color: textColor }}
      >
        {announcement.video_url && <ReactPlayer url={announcement.video_url} width="100%" height="50vh" controls />}

        <div className="px-6 py-8 flex-1 flex flex-col items-center justify-center">
          <h1 id="modal-title" className="text-3xl font-bold text-center mb-4">
            {announcement.title}
          </h1>

          {announcement.subtitle && (
            <h2 id="modal-description" className="text-xl text-center mb-4 opacity-90">
              {announcement.subtitle}
            </h2>
          )}

          {(announcement.long_description || announcement.text) && (
            <p className="mt-4 mb-8 text-center text-lg opacity-80 whitespace-pre-wrap">
              {announcement.long_description || announcement.text}
            </p>
          )}

          <AnnouncementOptionButtons
            options={announcement.options}
            announcementId={announcement.uuid}
            userResponse={announcement.user_response}
            bgColor={bgColor}
            textColor={textColor}
            isSubmitting={isSubmitting}
            variant="modal"
            respond={respond}
            onComplete={onClose}
          />
        </div>
      </div>
    </Modal>
  );
};
